/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "88")


  
    
export interface API56306Item {
  
  /** 用户id */
  userId?: string;
  
  /** 用户头像地址，替代dingdingHeadIconUrl */
  headIconUrl?: string;
  
  /** 业务id */
  userName?: string;
  
  /** 真实姓名 */
  realName?: string;
  
  /** 用户联系手机号 */
  userPhone?: string;
  
  /** 是否离职 */
  leaveJob?: boolean;
  
};
    
  



export interface API56306Req {
  
  /** 用户名称或者真实姓名 */
  key: string;
    
  /** 是否是外部用户，0：否；1：是 */
  isOut?: string;
    
  /** 不传或者false，只查询在职员工，若true，则表示查询所有用户（包含离职人员） */
  isAll?: string;
    
};



export interface API56306Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** UserDto  */
  data?: API56306Item[];
  /**   */
  exceptionMsg?: string;
  
};


// 56306 通过特定关键词查找用户数据

export interface IUseGetAPI56306Return {
  /** 通过特定关键词查找用户数据: 接口请求状态 */
  isAPI56306Loading: boolean;
  /** 通过特定关键词查找用户数据: 接口请求返回数据 */
  dataAPI56306: API56306Res;
  /**  通过特定关键词查找用户数据: 接口数据请求方法 */
  fetchAPI56306Data:  (inputs: API56306Req, config?: YWRequestConfig) => Promise<API56306Res>;
  /** 通过特定关键词查找用户数据: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI56306 = ():IUseGetAPI56306Return => {
  let isMount = true;
  const [isAPI56306Loading, setIsAPI56306Loading] = useState(false);
  const [dataAPI56306, setDataAPI56306] = useState<API56306Res>({} as API56306Res);
  const requestUrl = `${basePath}/ywwl-admin/user/list/like/query`;

  const fetchAPI56306Data = async (inputs: API56306Req, config?: YWRequestConfig): Promise<API56306Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API56306Req>) || {}) as API56306Req;
    
  
    if ( isMount ) {
      setIsAPI56306Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API56306Res>(`${basePath}/ywwl-admin/user/list/like/query?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI56306(res || {} as API56306Res);
        setIsAPI56306Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56306Loading(false);
      }
      return false as unknown as API56306Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56306Loading,
    dataAPI56306,
    fetchAPI56306Data,
    requestUrl,
  }
}

